import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import API_ENDPOINTS, { CONVERT_TO_SLUG } from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { Toast } from 'primereact/toast';
import Layout from '../common/Layout';
import { useForm } from 'react-hook-form';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { TabView, TabPanel } from 'primereact/tabview';
import SeoCategory from './SeoCategory';

const AddCategory = () => {

    const [activeIndex, setActiveIndex] = useState(0);

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const [categoryData, setCategoryData] = useState([])

    useEffect(() => {
        isEdit && getCategoryData()
    }, [])

    const schema = yup.object({
        categoryName: yup.string().required("Name is required"),
        categoryIcon: yup.mixed().test("icon-required", "Course icon is required", function (value) { return ((value && value.length > 0) || categoryData?.categoryIcon); }),
        categorySlug: yup.string().notRequired(), 
        metaTitle: yup.string().notRequired(), 
        metaDescription: yup.string().notRequired(), 
        metaKeywords: yup.string().notRequired(),  
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, watch, resetField, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            categoryName: '',
            categoryIcon: null,
            categorySlug: '',
            metaTitle: '',
            metaDescription: '',
            metaKeywords: '',
            isActive: '',
        })
    }

    const previewImage = watch('categoryIcon')

    const getCategoryData = () => {
        ApiHelper.get(`${API_ENDPOINTS.CATEGORY}/${id}`).then((res) => {
            if (res.status === 200) {
                setCategoryData(res.data.data)
                reset({
                    categoryName: res.data.data.categoryName,
                    categorySlug: res.data.data.categorySlug,
                    metaTitle: res.data.data.metaTitle,
                    metaDescription: res.data.data.metaDescription,
                    metaKeywords: res.data.data.metaKeywords,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const onSubmit = (data) => {
        const formData = new FormData()
        if (!data.categorySlug) {
            data.categorySlug = CONVERT_TO_SLUG(data?.categoryName)
        } else {
            data.categorySlug = CONVERT_TO_SLUG(data?.categorySlug)
        }

        if (data?.metaTitle) formData.append('metaTitle', data?.metaTitle);
        if (data?.metaKeywords) formData.append('metaKeywords', data?.metaKeywords);
        if (data?.metaDescription) formData.append('metaDescription', data?.metaDescription);

        formData.append('categoryName', data?.categoryName);
        formData.append('categorySlug', data?.categorySlug);
        if (data.categoryIcon) {
            formData.append('categoryIcon', data.categoryIcon[0]);
        }
        formData.append('isActive', data.isActive);
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };
    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.CATEGORY}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/category')
                }, 900)
            }
        }).catch((error) => {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.CATEGORY}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/category')
                }, 900)
            }
        }).catch((error) => {
            console.log('toast: ', toast);
            
            toast.current?.show({ severity: 'error', summary: 'Error', detail: error?.response?.data?.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = () => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteIcon(),
        });
    };

    const deleteIcon = () => {
        ApiHelper.post(`${API_ENDPOINTS.CATEGORY}/delete-icon/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getCategoryData()
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/category')}> Category </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/category" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                                <TabPanel header="Details">
                                                        <div class="row mb-3">
                                                            <div class="col-md-3 mb-3">
                                                                <label class="form-label">Name</label>
                                                                <input type="text" name="categoryName" class="form-control" {...register("categoryName")} />
                                                                <small className="text-danger">{errors.categoryName?.message}</small>
                                                            </div>
                                                            {categoryData?.categoryIcon ? (
                                                                <div class="col-md-3 mb-3">
                                                                    <label class="form-label">Category Icon</label>
                                                                    <br />
                                                                    <div>
                                                                        <div class="d-inline-block ">
                                                                            <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                                <a target="_blank">
                                                                                    <img src={`${process.env.REACT_APP_BASE_URL}/${categoryData?.categoryIcon}`} class="img-thumbnail" />
                                                                                </a>
                                                                                <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog()}> &times; </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <small className="text-danger">{errors.categoryIcon?.message}</small>
                                                                </div>
                                                            ) : (
                                                                <div class="col-md-3">
                                                                    <label class="form-label">Upload Product Photo</label>
                                                                    <br />
                                                                    <div>
                                                                        <input type="file" accept=".jpeg, .jpg, .png, .webp" name="photo" {...register("categoryIcon")} class="form-control fileMultiInput" />
                                                                    </div>
                                                                    <small className="text-danger">{errors.categoryIcon?.message}</small>
                                                                    {previewImage?.[0] && (
                                                                        <div class="mt-3 mb-2">
                                                                            <div class="d-inline-block ">
                                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                                    <a target="_blank">
                                                                                        <img src={URL.createObjectURL(previewImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                                    </a>
                                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('categoryIcon')}> &times; </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                    }
                                                                </div>
                                                            )}
                                                            <div class="col-md-3 mt-2">
                                                                <label class="form-label">Status</label>
                                                                <div class="form-check form-switch mb-2">
                                                                    <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                                    <small className="text-danger">{errors.isActive?.message}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                </TabPanel>
                                                <TabPanel header="SEO Setting" disabled={!isEdit ? true : false} >
                                                    <SeoCategory seoData={categoryData} onSubmit={onSubmit} setActiveIndex={setActiveIndex} toast={toast} getCategoryData={getCategoryData} register={register} />
                                                </TabPanel>
                                            </TabView>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddCategory
